import "./TeamDetails.css";
import React, { useState } from "react";
import { GrInstagram, GrGithub } from "react-icons/gr";
import { IoMailOutline } from "react-icons/io5";
import { FaLinkedinIn } from "react-icons/fa";

const TeamDetails = ({
  name = null,
  role = null,
  insta = null,
  linkedin = null,
  mail = null,
  github = null,
  image,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div className="gits-member-wrapper">
      <div
        className="gits-member-card"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="gits-member-content">
          <div className="gits-member-img-container">
            <div 
              className={`gits-member-img ${isHovered ? "gits-img-hovered" : ""}`}
              style={{
                backgroundImage: `url(${image})`,
              }}
            ></div>
          </div>
          <div className="gits-member-info">
            <h3 className="gits-member-name">{name}</h3>
            <span className="gits-member-role">{role}</span>
          </div>
        </div>
        <ul className="gits-member-social">
          {insta && (
            <li className="gits-social-item" style={{ "--i": 1 }}>
              <a href={insta} target="_blank" rel="noreferrer" className="gits-social-link">
                <GrInstagram />
              </a>
            </li>
          )}
          {github && (
            <li className="gits-social-item" style={{ "--i": 2 }}>
              <a href={github} target="_blank" rel="noreferrer" className="gits-social-link">
                <GrGithub />
              </a>
            </li>
          )}
          {linkedin && (
            <li className="gits-social-item" style={{ "--i": 3 }}>
              <a href={linkedin} target="_blank" rel="noreferrer" className="gits-social-link">
                <FaLinkedinIn />
              </a>
            </li>
          )}
          {mail && (
            <li className="gits-social-item" style={{ "--i": 4 }}>
              <a href={`mailto:${mail}`} target="_blank" rel="noreferrer" className="gits-social-link">
                <IoMailOutline />
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default TeamDetails;